export interface MainPropSelect {
    select: {
        [layer: number]: string[]
    }
    specials: {
        [layer: number]: string[]
    }
}
export interface MainPropState {
    info: MainPropSelect
    events: {
        [layer: number]: Event[]
    }
}

function getInitialState(): MainPropState {
    return {
        events: {
            [0]: []
        },
        info: getInitialStartState()
    }
}

function getInitialStartState(): MainPropSelect {
    return {
        select: {},
        specials: {}
    }
}
export { getInitialState, getInitialStartState }
